import client from "../client";
import { IDENTIFY_TYPE } from "../../constants/enum";

/**
 * 인증요청 API — NICE 통합인증 V3
 * data는 인증 결과 원문이 아니라 서버가 발급한 1회성 조회 키(certSessionKey)
 * @param {*} simpleId
 * @param {*} data certSessionKey
 */

export const callDormantUser = async ({ type, data, simpleId }) => {
  if (type && data && simpleId) {
    const urlType = type === IDENTIFY_TYPE.MOBILE ? "phone" : "ipin";
    const encodedData = encodeURIComponent(data);

    const result = await client
      .get(
        `/api/v2/user/awake/${urlType}?simpleId=${simpleId}&certKey=${encodedData}`
      )
      .then((res) => {
        if (res.data) {
          return res.data.status;
        }
      })
      .catch((e) => console.error(e));

    if (result === 0) {
      return true;
    } else {
      return false;
    }
  }
};

export const callNormalUser = async ({ type, data, simpleId }) => {
  if (type && data && simpleId) {
    const urlType = type === IDENTIFY_TYPE.MOBILE ? "phone" : "ipin";
    const encodedData = encodeURIComponent(data);

    const result = await client
      .get(
        `/api/v2/user/children/re-cert/${urlType}?simpleId=${simpleId}&certKey=${encodedData}`
      )
      .then((res) => {
        if (res.data) {
          return res.data.status;
        }
      })
      .catch((e) => console.error(e));

    if (result === 0) {
      return true;
    } else {
      return false;
    }
  }
};
